//时间格式化
var util = {
    timeHandle: function (time) {
        try {
            var hmsStr = time.split(' ')[1];
            var hmsArr = hmsStr.split(':');
            hmsArr.length = 2;
            return hmsArr.join(':');
        } catch (e) {
            return time;
        }
    },
    timeHandleNosecond: function (time) {
        try {
            return time.substring(0, time.lastIndexOf(':'));
        } catch (e) {
            return time;
        }
    },
    timeHandleDay: function (time) {
        try {
            return time.substring(0, time.lastIndexOf(' '));
        } catch (e) {
            return time;
        }
    },
    getDate: function (time) {

            return time.split(' ')[0].split('-').join('-');

    }
};



module.exports = util;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pagelist.pc/app/modules/util/index.js